/* eslint-disable vue/no-mutating-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent } from "vue";
import { globals } from "@/main";
import { localOffset, localPagination } from "@/dto/local.key.dto";

export default defineComponent({
  name: "c-meta",

  props: {
    meta: { type: Object as () => Record<string, any>, default: () => ({}) },
    isLoading: { type: Boolean as () => boolean, default: false },
    data: { type: Array, default: () => [] },
  },

  emits: ["onMeta"],

  data() {
    return {
      page: 1,
      limit: globals.$helper.limitQuery(),
      inputPage: null as null | number,
      select: { menu: "" } as { menu: string },
      mockOptions: [
        { val: "5", label: "5" },
        { val: "10", label: "10" },
        { val: "25", label: "25" },
        { val: "30", label: "30" },
        { val: "50", label: "50" },
        { val: "60", label: "60" },
        { val: "70", label: "70" },
        { val: "80", label: "80" },
        { val: "90", label: "90" },
        { val: "100", label: "100" },
        { val: "110", label: "110" },
        { val: "120", label: "120" },
      ],
    };
  },

  methods: {
    backPage(type: string) {
      this.select.menu = type;
      if (this.meta.page == 1) {
        this.meta.page = this.meta;
      } else {
        this.meta.page--;
      }

      this.updateRoute();
    },

    goTo(page: number) {
      if (page <= 0 || page > this.meta.totalPage) {
        return;
      }

      this.meta.page = page;
      this.updateRoute();
    },

    updateRoute(changeLimit?: number) {
      let routeQuery = {
        page: 1,
        limit: Number(this.meta.limit),
        length: Number(this.meta.length),
        offset: 0,
        totalPage: Number(this.meta.totalPage),
      };

      const limit = Number(this.meta.limit) || Number(this.meta.limit);

      if (!changeLimit) {
        routeQuery = {
          page:
            limit !== Number(this.meta.limit)
              ? 1
              : Number(this.meta.page) || Number(this.meta.page),
          limit: Number(this.meta.limit),
          length: Number(this.meta.length),
          offset:
            limit !== Number(this.meta.limit)
              ? 0
              : globals.$helper.calculateOffset(
                  Number(this.meta.page) || Number(this.meta.page),
                  limit
                ),
          totalPage: Number(this.meta.totalPage),
        };
      } else {
        routeQuery = {
          page: 1,
          length: Number(this.meta.length),
          limit: Number(this.meta.limit),
          offset: 0,
          totalPage: Number(this.meta.totalPage),
        };
      }

      const offset = routeQuery.offset;
      localStorage.setItem(localOffset, String(offset));

      this.$emit("onMeta", routeQuery);
    },

    changeLimitQuery() {
      const limit = Number(this.meta.limit);

      localStorage.setItem(localPagination, this.meta.limit);
      this.updateRoute(limit);
    },

    onkeypress(evt: KeyboardEvent) {
      if (this.checkDots(evt)) {
        evt.preventDefault();
      }

      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },

    handleKeyDown(evt: KeyboardEvent) {
      const target = evt.target as HTMLInputElement;
      if (evt.ctrlKey || evt.metaKey) {
        if (!/^[\d.]+$/.test(target.value)) {
          evt.preventDefault();
        }
      }
    },

    checkDots(evt: KeyboardEvent) {
      const dotCount =
        (evt.target as HTMLInputElement).value.match(/\./g)?.length || 0;
      return dotCount && evt.key === ".";
    },
  },
});
